import Image from 'next/legacy/image';

import { BodyRegular } from '../../common/body';
import { H3 } from '../../common/headline';
import { TakeOurQuizButton } from '../Hero/TakeOurQuizCTA';

import verticalSquiggle from '@public/img/how-it-works/vertical-squiggle.svg';
import womanWithGlassOfWater from '@public/img/people/woman-with-glass-of-water.png';
import VitalityPartner from '@public/img/how-it-works/vitality-partner.png';

const NiceApprovalImage = () => (
  <div className="relative flex aspect-[563/486] h-min w-full max-w-[563px]">
    <div className="absolute left-0 top-0 flex h-full w-[42%]">
      <Image
        src={verticalSquiggle}
        alt={'Background brushstroke'}
        layout="fill"
      />
    </div>
    <div className="absolute right-0 top-[5%] aspect-[424/394] h-[81%]">
      <Image
        src={womanWithGlassOfWater}
        alt={'Woman smiling and holding a glass of water'}
        layout="fill"
      />
    </div>
  </div>
);

type Props = {
  utmCampaign?: string;
  utmMedium?: string;
  utmSource?: string;
  medicationType: 'Wegovy' | 'Mounjaro';
};

export const NiceApprovalSection = ({
  utmCampaign,
  utmMedium,
  utmSource,
  medicationType,
}: Props): JSX.Element => (
  <div className="flex w-full justify-center bg-dawn-blue md:h-[653px]">
    <div className="relative flex w-[1440px] items-center justify-center gap-14 px-4 py-20 md:max-w-none md:justify-between md:p-[60px]">
      <div className="flex h-full w-full max-w-[454px] flex-col justify-center gap-y-8 text-left text-mono-white md:text-left">
        <H3>
          <span className="text-blue">Why choose Second Nature?</span>
          <br />
          For peace of mind.
        </H3>
        <div className="md:max-w-[418px]">
          <BodyRegular>
            Second Nature has worked with the NHS for over 6 years to provide
            weight-loss programmes across the UK.
            <br />
            <br />
            Whilst our {medicationType} weight-loss programmes are private and
            not currently used by the NHS, we{"'"}ve built the programmes with a
            focus on scientific evidence, patient safety, and data security.
            <br />
            <br />
            We{"'"}ve also partnered with Vitality Health to help their 1.7
            million members achieve their health goals.
            <br />
            <br />
            We hope that our 6+ years of working with the NHS and our track
            record of effective weight-loss results will give you peace of mind
            to give us a try.
          </BodyRegular>
        </div>
        <div className="flex justify-center md:justify-start">
          <Image
            src={VitalityPartner}
            alt="Vitality Health Partner"
            height={48}
            width={189.4}
          />
        </div>
        <div className="mb-4 w-full md:hidden">
          <NiceApprovalImage />
        </div>
        <div className="flex w-full justify-center md:justify-start">
          <div className="w-[351px] md:w-fit">
            <TakeOurQuizButton
              ctaText="Check my eligibility"
              location="Nice Approval Section"
              colour="NavyBlue"
              type="Primary"
              utmMedium={utmMedium}
              utmCampaign={utmCampaign}
              utmSource={utmSource}
              fullWidth
              isGlp1
            />
          </div>
        </div>
      </div>
      <div className="hidden w-full justify-center md:flex">
        <NiceApprovalImage />
      </div>
    </div>
  </div>
);
